<div class="wpee-edit-profile-inner profile-section-content">
    <div class="view-details-content-wrap section1">
        <ul class="profile-user-info no-list" *ngIf="!loader">
            <li>
                <strong>I am:</strong>
                <span>{{userData?.gender?.name}}</span>
            </li>
            <li>
                <strong>Seeking a:</strong>
                <span>{{userData?.seeking_gender?.name }}</span>
            </li>
            <li>
                <strong>Age:</strong>
                <span>{{userData?.age }}</span>
            </li>
            <li>
                <strong>Country:</strong>
                <span>{{userData?.country?.name}}</span>
            </li>
            <li>
                <strong>State:</strong>
                <span>{{userData?.state?.name}}</span>
            </li>
        </ul>
        <div [ngClass]="{'shine': loader}">

        </div>
    </div>
    <div class="view-details-content-wrap section2" *ngIf="!userData.isPrivate && !loader">
        <div class="wpee-sub-heading">Interest In:</div>
        <ul class="dspdp-other-details dsp-user-detail-info no-list">
            <li class="d-flex">
                <strong>Seeking:</strong>
                <span class="details">{{userData?.seeking_for?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Religion:</strong>
                <span class="details">{{userData?.religion?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Ethnicity:</strong>
                <span class="details">{{userData?.ethnicity?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Marital Status:</strong>
                <span class="details">{{userData?.marital_status?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Children:</strong>
                <span class="details">{{userData?.children?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Body Type:</strong>
                <span class="details">{{userData?.body_type?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Smoker:</strong>
                <span class="details">{{userData?.smoking_habit?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Drink:</strong>
                <span class="details">{{userData?.drinking_habit?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Employment:</strong>
                <span class="details">{{userData?.employment?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>Education:</strong>
                <span class="details">{{userData?.education?.name || '-'}}</span>
            </li>
            <li class="d-flex">
                <strong>My Match:</strong>
                <span class="details" [title]="userData?.my_match || '-'">
                    {{ userData?.my_match | truncate:40 }}
                </span>
            </li>
            <li class="d-flex">
                <strong>Pets:</strong>
                <span class="details">{{userData?.pets?.name || '-'}}</span>
            </li>
            <li class="li-fullwidth">
                <strong>About Me:</strong>
                <span class="details" [title]="userData?.about || '-'">
                    {{ userData?.about | truncate:40 }}
                </span>
            </li>
            <li class="li-fullwidth">
                <strong>My Interests:</strong>
                <span class="details" [title]="userData?.interest || '-'">
                    {{ userData?.interest | truncate:40 }}
                </span>
            </li>
        </ul>
    </div>
</div>